import React from "react";

const NoOptions = () => {
    return (
        <div className="dropdown-menu" role="listbox">
            <div className="dropdown-item -error">No Options</div>
        </div>
    );
};

export default NoOptions;
